import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Text from "@Components/Text";
import { Dropdown } from "semantic-ui-react";
import styles from "./styles.module.css";

const colors = [
	// Colores básicos oscuros (Mantenidos por compatibilidad)
	{ name: "red", label: "Rojo" },
	{ name: "green", label: "Verde" },
	{ name: "teal", label: "Verde Azulado" },
	{ name: "blue", label: "Azul" },
	{ name: "brown", label: "Marrón" },
	{ name: "black", label: "Negro" },
	{ name: "purple", label: "Púrpura" },
	{ name: "indigo", label: "Índigo" },
	{ name: "#0c440d", label: "Verde Oscuro" },
	{ name: "#1c2833", label: "Azul Medianoche" },
	{ name: "#641e16", label: "Rojo Vino Oscuro" },
	{ name: "#145a32", label: "Verde Bosque" },
	{ name: "#4a235a", label: "Ciruela Oscuro" },
	{ name: "#154360", label: "Azul Marino Oscuro" },
	{ name: "#6e2c00", label: "Marrón Cacao" },
	{ name: "#117864", label: "Esmeralda Profundo" },
	{ name: "#873600", label: "Óxido Oscuro" },
	{ name: "#424949", label: "Gris Pizarra" },
];

const colorOptions = colors.map(({ name, label }) => {
	return {
		key: name,
		text: label,
		value: name,
		content: (
			<div
				style={{
					backgroundColor: name,
					color: "white",
					padding: "10px",
					borderRadius: "5px",
					textAlign: "center",
				}}>
				{label}
			</div>
		),
	};
});

const ColorPickerDropdown = ({ currentColor, setCurrentColor, disabled }) => {
	const [upward, setUpward] = useState(true);

	useEffect(() => {
		const checkScreenSize = () => {
			if (window.innerWidth > 1600) {
				setUpward(false);
			} else {
				setUpward(true);
			}
		};
		checkScreenSize();
		window.addEventListener("resize", checkScreenSize);
		return () => {
			return window.removeEventListener("resize", checkScreenSize);
		};
	}, []);
	return (
		<div className={styles.container}>
			<Text className={styles.textColor}>Color:</Text>
			<Dropdown
				placeholder="Seleccionar"
				fluid
				selection
				clearable
				options={colorOptions}
				value={currentColor}
				onChange={(e, { value }) => {
					return setCurrentColor(value);
				}}
				disabled={disabled}
				upward={upward}
				style={{
					backgroundColor: currentColor,
					color: "white",
				}}
			/>
		</div>
	);
};

ColorPickerDropdown.propTypes = {
	currentColor: PropTypes.string,
	setCurrentColor: PropTypes.func,
	disabled: PropTypes.bool,
};

export default ColorPickerDropdown;
